import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@ngx-translate/core";
function VersionPopupComponent_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.prefix + "FRONTEND_VERSION"));
  }
}
function VersionPopupComponent_td_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.prefix + "BACKEND_VERSION"));
  }
}
function VersionPopupComponent_td_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.prefix + "LIB_VERSION"));
  }
}
function VersionPopupComponent_td_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.prefix + "DB_VERSION"));
  }
}
export class VersionPopupComponent {
  prefix = 'UI-LIB.HEADER.ENVIRONMENT_TAG.TOOLTIP.';
  frontendVersion = '';
  backendVersion = '';
  libVersion = '';
  dbVersion = '';
  static ɵfac = function VersionPopupComponent_Factory(t) {
    return new (t || VersionPopupComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: VersionPopupComponent,
    selectors: [["geaui-version-popup"]],
    inputs: {
      frontendVersion: "frontendVersion",
      backendVersion: "backendVersion",
      libVersion: "libVersion",
      dbVersion: "dbVersion"
    },
    decls: 18,
    vars: 8,
    consts: [["aria-label", "version overview table", 1, "version-popup"], [1, "version-popup-row"], [4, "ngIf"]],
    template: function VersionPopupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "table", 0);
        i0.ɵɵelement(1, "th");
        i0.ɵɵelementStart(2, "tr", 1);
        i0.ɵɵtemplate(3, VersionPopupComponent_td_3_Template, 3, 3, "td", 2);
        i0.ɵɵelementStart(4, "td");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "tr", 1);
        i0.ɵɵtemplate(7, VersionPopupComponent_td_7_Template, 3, 3, "td", 2);
        i0.ɵɵelementStart(8, "td");
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "tr", 1);
        i0.ɵɵtemplate(11, VersionPopupComponent_td_11_Template, 3, 3, "td", 2);
        i0.ɵɵelementStart(12, "td");
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "tr", 1);
        i0.ɵɵtemplate(15, VersionPopupComponent_td_15_Template, 3, 3, "td", 2);
        i0.ɵɵelementStart(16, "td");
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.frontendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.frontendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.backendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.backendVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.libVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.libVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dbVersion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.dbVersion);
      }
    },
    dependencies: [i1.NgIf, i2.TranslatePipe],
    styles: [".version-popup[_ngcontent-%COMP%]{background:var(--geaui-night-blue);padding:0 10px;font-size:12px;border-radius:4px;box-shadow:4px 4px 10px -4px var(--geaui-dark-gray);color:var(--geaui-white)}.version-popup[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{line-height:20px}.version-popup[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(1){padding-right:10px}.version-popup[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(2){font-weight:600}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VersionPopupComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-version-popup',
      template: "<table class=\"version-popup\" aria-label=\"version overview table\">\n  <th></th>\n  <tr class=\"version-popup-row\">\n    <td *ngIf=\"frontendVersion\">{{ prefix + 'FRONTEND_VERSION' | translate }}</td>\n    <td>{{ frontendVersion }}</td>\n  </tr>\n  <tr class=\"version-popup-row\">\n    <td *ngIf=\"backendVersion\">{{ prefix + 'BACKEND_VERSION' | translate }}</td>\n    <td>{{ backendVersion }}</td>\n  </tr>\n  <tr class=\"version-popup-row\">\n    <td *ngIf=\"libVersion\">{{ prefix + 'LIB_VERSION' | translate }}</td>\n    <td>{{ libVersion }}</td>\n  </tr>\n  <tr class=\"version-popup-row\">\n    <td *ngIf=\"dbVersion\">{{ prefix + 'DB_VERSION' | translate }}</td>\n    <td>{{ dbVersion }}</td>\n  </tr>\n</table>\n",
      styles: [".version-popup{background:var(--geaui-night-blue);padding:0 10px;font-size:12px;border-radius:4px;box-shadow:4px 4px 10px -4px var(--geaui-dark-gray);color:var(--geaui-white)}.version-popup tr{line-height:20px}.version-popup td:nth-child(1){padding-right:10px}.version-popup td:nth-child(2){font-weight:600}\n"]
    }]
  }], null, {
    frontendVersion: [{
      type: Input
    }],
    backendVersion: [{
      type: Input
    }],
    libVersion: [{
      type: Input
    }],
    dbVersion: [{
      type: Input
    }]
  });
})();
